import {
  APPLICATIONS_REJECT_REASON_MAPPING,
  APPLICATIONS_STATUSES_MAPPING,
  APPLICATIONS_TABLE_SORTING_FIELDS,
  APPLICATION_TABLE_EMPTY_VALUE,
} from 'components/applications/applications.constants';
import {
  ApplicationRejectReason,
  ApplicationSortingField,
  ApplicationsTableStatus,
  ApplicationStatus,
} from 'components/applications/applications.enums';
import { SortByField } from 'components/applications/applications.types';

export const convertBorrowerNames = (firstName?: string | null, lastName?: string | null) => {
  if (!firstName) {
    return APPLICATION_TABLE_EMPTY_VALUE;
  }

  if (!lastName) {
    return firstName;
  }

  return `${firstName} ${lastName}`;
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export const convertLoanAmount = (value: string | number) => {
  return formatter.format(+value);
};

export const convertStatus = (status: ApplicationStatus) => {
  return APPLICATIONS_STATUSES_MAPPING[status] || APPLICATION_TABLE_EMPTY_VALUE;
};

export const getLoanDecision = (rejectReason?: ApplicationRejectReason[] | null, status?: string) => {
  if (status === ApplicationsTableStatus.Funded) {
    return ApplicationsTableStatus.Funded;
  }

  if (!rejectReason?.length) {
    return APPLICATION_TABLE_EMPTY_VALUE;
  }

  const reasonKey = rejectReason.length === 1 ? rejectReason[0] : rejectReason.join(' + ');

  return APPLICATIONS_REJECT_REASON_MAPPING[reasonKey as ApplicationRejectReason] || APPLICATION_TABLE_EMPTY_VALUE;
};

export const getSortByFields = (sortField: ApplicationSortingField, isSortDesc: boolean): SortByField[] => {
  if (APPLICATIONS_TABLE_SORTING_FIELDS.includes(sortField)) {
    return [{ sortField: sortField, isSortDesc: isSortDesc }];
  }

  return [];
};

export const getSortByVariables = (sortField: ApplicationSortingField, isSortDesc: boolean): SortByField[] => {
  if (!APPLICATIONS_TABLE_SORTING_FIELDS.includes(sortField)) {
    return [{ sortField: sortField, isSortDesc: isSortDesc }];
  }

  return [];
};
